import React from 'react';
import { Route } from 'react-router-dom';
import Dashboard from '../components/Dashboard';
import Home from '../components/Home';
import HostRegistration from '../modules/host/HostRegistration';
import HostLogin from '../modules/host/HostLogin';
import ReviewerComments from '../modules/host/ReviewerComments';
import AuthorsList from '../modules/host/AuthorsList';
import ReviewerList from '../modules/host/ReviewerList';
import SubmissionList from '../modules/host/SubmissionList';
import ReviewRepliesList from '../modules/host/ReviewRepliesList';
import ReviewerDecMatrix from '../modules/host/ReviewerDecMatrix';
import PlatformManager from '../modules/host/PlatformManager';
import VerifyReviewer from '../modules/host/VerifyReviewer';
import VerifyAuthor from '../modules/host/VerifyAuthor';
import SubmissionAssignment from '../modules/host/SubmissionAssignment';
import ChangeReviewer from '../modules/host/ChangeReviewer';
import ProtectedRoute from './ProtectedRoute';


const HostRoutes = (
  <>
    <Route path="/register" element={<HostRegistration />} />
    <Route path="/login" element={<HostLogin />} />
    
    <Route element={<ProtectedRoute requiredRole="host" />}>
      <Route path="/host" element={<Dashboard />}>
        <Route path="dashboard" element={<Home/>}/>
        <Route path="verify-reviewer" element={<VerifyReviewer />} />
        <Route path="verify-author" element={<VerifyAuthor />} />
        <Route path="submission-assignment" element={<SubmissionAssignment />} />
        <Route path="reviewer-comments" element={<ReviewerComments />} />
        <Route path="authors-list" element={<AuthorsList />} />
        <Route path="reviewer-list" element={<ReviewerList />} />
        <Route path="submission-list" element={<SubmissionList />} />
        <Route path="review-replies-list" element={<ReviewRepliesList />} />
        <Route path="reviewer-decision-matrix" element={<ReviewerDecMatrix />} />
        {/* <Route path="change-reviewer" element={<ChangeReviewer />} /> */}
        <Route path="/host/Change-reviewer/:submissionID" element={<ChangeReviewer />} />

      </Route>
    </Route>
  </>
);

export default HostRoutes;
